import "./App.css";
import "@bryntum/scheduler/scheduler.classic-light.css";

import React from "react";
import { useSelector } from "react-redux";

import { ConfigProvider } from "antd";

import Login from "./containers/Login";
import Router from "./Router";

import dayjs from "dayjs";
import locale from "antd/es/locale/fr_FR";
import "dayjs/locale/fr";

import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isBetween from "dayjs/plugin/isBetween";
import duration from "dayjs/plugin/duration";

import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(duration);

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

dayjs.locale("fr");

const App = () => {
  const utilisateur = useSelector((state) => state.utilisateur.data);
  const exercice = useSelector((state) => state.exercice.annee);

  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorPrimary: "#f4c181",
        },
        components: {
          Layout: {
            headerBg: "#fff",
            siderBg: "#002140",
          },
          Menu: {
            darkItemBg: "#002140",
            darkSubMenuItemBg: "#001529",
            itemBorderRadius: 0,
            subMenuItemBorderRadius: 0,
            itemMarginInline: 0,
          },
        },
      }}
    >
      {/* key : un changement d'exercice remonte toute l'application (onglets, states locaux, chargement initial) */}
      {!utilisateur || utilisateur.length === 0 ? <Login /> : <Router key={exercice} />}
    </ConfigProvider>
  );
};

export default App;
